// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3qP5G","messages":"Chat_messages__2N5IR","dateDivider":"Chat_dateDivider__1DO2o"};